import {Button, Card, Stack, TextField} from "@mui/material"
import React, {useState} from "react"
import {useDispatch} from "react-redux"
import {useNavigate, useParams} from "react-router-dom"
import {useAdvancedSearchCMMutation} from "../../core/api/cloclmaker-state-api"
import {types} from "../../core/reducers/commonData"
import MultiSearch from "./MultiSearch"

const PROGRESS_SEARCH_ACTIONS = ["dashboard", "state"]

export default function SearchBarCM() {
    const {game, action} = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [progressUserId, setProgressUserId] = useState("")
    const showProgressSearch = PROGRESS_SEARCH_ACTIONS.includes(action)

    const submitProgress = () => {
        const userId = progressUserId.trim()
        if (!userId) return
        dispatch({type: types.SET_DEVICE_ID, payload: {deviceId: userId}})
        dispatch({type: types.SET_STATE_ID, payload: {stateId: ""}})
        navigate(`/${game}/${action || "dashboard"}/${userId}?source=progress`)
    }

    return (
        <Stack spacing={1} sx={{width: "100%"}}>
            <MultiSearch useSearchHook={useAdvancedSearchCMMutation}/>
            {showProgressSearch && (
                <Card sx={{width: "100%", p: 2, borderLeft: 4, borderColor: "warning.main"}}>
                    <Stack direction="row" spacing={1} sx={{alignItems: "center"}}>
                        <TextField
                            fullWidth
                            label="User ID"
                            value={progressUserId}
                            onChange={(e) => setProgressUserId(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault()
                                    submitProgress()
                                }
                            }}
                        />
                        <Button
                            size="small"
                            color="warning"
                            onClick={submitProgress}
                            disabled={!progressUserId.trim()}
                        >
                            Search (WEB)
                        </Button>
                    </Stack>
                </Card>
            )}
        </Stack>
    )
}
